export default __webpack_public_path__ + "static/media/portfolio-site-icon.e0dc3950.png";